module.exports = __webpack_public_path__ + "img/40343300.fc73339c.png";